var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upsell-marketing-domains-container" },
    [
      _vm._l(_vm.uneditableDomains, function(domain) {
        return _c(
          "div",
          {
            key: domain.hash,
            staticClass: "upsell-marketing-domains-container__uneditable-domain"
          },
          [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [_vm._v(_vm._s(domain.sender))]
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.editableDomains, function(domain) {
        return _c("ChargebeeUpsellMarketingDomainsItem", {
          key: domain.hash,
          attrs: { domain: domain },
          on: {
            onRemoveDomain: function($event) {
              return _vm.onRemoveDomain(domain)
            },
            domainValidated: _vm.onDomainValidation
          }
        })
      }),
      _vm._v(" "),
      _vm.shouldDisplayAddDomain
        ? _c(
            "div",
            { staticClass: "upsell-marketing-domains__add-domain" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "pages.account.upsell.marketing.ChargebeeUpsellMarketingDomainsManager.add_other_domain"
                  ),
                  disabled: _vm.getEstimationLoading,
                  "left-icon": "plus",
                  type: "tertiary"
                },
                on: { click: _vm.onAddDomain }
              }),
              _vm._v(" "),
              _c("p", [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.numberFormatCurrency(
                            _vm.humanizeCentsPrice(_vm.unitPriceDomain)
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                /" +
                        _vm._s(_vm.recurrencyLabel(_vm.recurrence)) +
                        "\n            "
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }